export const UPDATE_ADD_MATERIAL_MENU_IS_OPEN = 'UPDATE_ADD_MATERIAL_MENU_IS_OPEN';

export function updateAddMaterialMenuIsOpen(value) {
  return {
    type: UPDATE_ADD_MATERIAL_MENU_IS_OPEN,
    payload: value,
  };
}



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/actions/updateAddMaterialMenuIsOpen.js